import { render, staticRenderFns } from "./Deferred.vue?vue&type=template&id=ea02be20&"
import script from "./Deferred.vue?vue&type=script&lang=js&"
export * from "./Deferred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports